import UAParser from 'ua-parser-js';

export const ROOT_URL = location.origin;
export const URL_HOST = location.host;

export const INPUT_TYPES = {
    TEXT: 'text',
    PASSWORD: 'password'
};

export const BREAK_POINT = {
    BREAK_POINT_DESKTOP: 1281,
    BREAK_POINT_TABLET: 1024,
    BREAK_POINT_MOBILE: 768
};

export const PasswordSource = {
    LINK_PASSWORD: 'LinkPassword',
    LINK_COMPLIANCE_PASSWORD: 'LinkCompliancePassword'
};

export const ValidationErrorCode = {
    LIVESEND_MANIFEST_OK: 'OK',
    LIVESEND_REQUIRE_PASSWORD: 'LIVESEND_REQUIRE_PASSWORD',
    LIVESEND_WRONG_PASSWORD: 'LIVESEND_WRONG_PASSWORD',
    LIVESEND_INVITATION_NOT_FOUND: 'LIVESEND_INVITATION_NOT_FOUND',
    LIVESEND_INVITATION_EXPIRED: 'LIVESEND_INVITATION_EXPIRED',
    LIVESEND_INVITATION_SESSION_ENDED: 'LIVESEND_INVITATION_SESSION_ENDED'
};

export const HTTPSTATUS = {
    NOT_FOUNT: 404,
    INTERNAL_SERVER_ERROR: 500
};

export const EventType = {
    DOWNLOADED: 'Downloaded'
};

export const ANONYMOUS_PATTERN = /Anonymous_\d{1,}/;
export const LiveSendCookies = {
    CONSENT_GDPR: 'ConsentGDPR_v2',
    SEISMIC_PREFERENCES: 'SeismicPreferences_v2',
    SEISMIC_COMPLIANCE_PREFERENCES: 'SeismicCompliancePreferences_v2',
    UNIQUE_INTERACTION_PROOF: 'UniqueInteractionProof_v2',
    WATERMARK_CONSENT_GDPR: 'ConsentGDPR_v3' // use to watermark content GDPR
};

export const UniversalPlayerMode = {
    PRESENT: 'present',
    READ: 'read'
};

export const ManifestFormatType = {
    FIRESTORM: 'Firestorm',
    VIDEO: 'Video',
    AUDIO: 'Audio'
};

export const uaParser = new UAParser();
export const SERVICE_ROOT_URL = `${ROOT_URL}/Services`;
export const LIVESEND_SERVICE_URL = `${SERVICE_ROOT_URL}/LiveSendServices.svc`;

export const TAG_A_PATTERN = /<a[^>]*href=['"]([^"]*)['"][^>]*>(.*?)<\/a>/g;

export const MY_PRIVACY_SETTING_VALUE = {
    STRICTLY_NECESSARY_COOKIES: 'STRICTLY_NECESSARY_COOKIES',
    ALL_TRACKING_AND_COOKIES: 'ALL_TRACKING_AND_COOKIES',
    ONLY_FUNCTIONAL_COOKIES: 'ONLY_FUNCTIONAL_COOKIES'
};

export const SHARE_RESULT_CODE = {
    ProhibitedRecipients: 'ProhibitedRecipients'
};

export const KeyBoardAction = {
    enter: 13
};

export const LOG_TYPE = {
    ERROR: 'Error',
    WARNING: 'Warning',
    Information: 'Information'
};

export const DISCLAIMER_TYPE = {
    NONE_DISCLAIMER: 'NoneDisclamer',
    WITH_PRIVACY_SETTING: 'DisclamerWithPrivacySetting',
    WITHOUT_PRIVACY_SETTING: 'DisclamerWithoutPrivacySetting',
    WITH_REJECT_ALL: 'DisclamerWithRejectAll'
};

export const DEFAULT_EN_DISCLAIMER = {
    WITH_PRIVACY_SETTING: 'When you view content, we like to provide you with the best experience we can. We share insights and activity with the sender of this content, as well as save your preferences for next time. By clicking "Accept & view", you agree to all tracking and cookies. You can learn more and set your own preferences in "My privacy settings". Visit our privacy policy for more information.',
    WITHOUT_PRIVACY_SETTING: 'When you view content, we like to provide you with the best experience we can. We share insights and activity with the sender of this content, as well as save your preferences for next time. By clicking "Accept & view", you agree to all tracking and cookies. Visit our privacy policy for more information.'
};

export const GDPR_DEFAULT_LINK = 'https://seismic.com/privacy-policy';

export const ConsentGDPRCookieValue = {
    ONLY_FUNCTIONAL_COOKIES: '0',
    ALL_TRACKING_AND_COOKIES: '1',
    STRICTLY_NECESSARY_COOKIES: '2'
};

export const SPECIAL_LANG_HANDLE_LIST = ['de-DE', 'tr-TR'];

export const DOWNLOAD_MODE = {
    OriginalFormat: 1,
    PDFOnly: 2,
    PDFOrOriginal: 3
};

export const ENABLED_WATERMARK = 'content-assets-watermark-enable';

export const TRACKING_TYPES = {
    STRICTLY_NECESSARY: 'StrictlyNecessary',
    ALL_TRACKING: 'AllTracking',
    ONLY_FUNCTIONAL: 'FunctionalTracking',
    UNKNOWN: 'Unknown'
};
